import React from "react";

export default class MKhomePlaceholder extends React.PureComponent {
  render() {
    return (
      <div className="store-placeholder">
        <style>
          {`
            @keyframes shimmerAnimation {
              0% {
                background-position: -468px 0;
              }
              100% {
                background-position: 468px 0;
              }
            }

            .store-placeholder {
              display: flex;
              flex-direction: column;
              padding: 10px;
            }

            .banner-placeholder {
              height: 200px;
              background-color: #e0e0e0;
              position: relative;
              margin-bottom: 15px;
              overflow: hidden;
              background-image: linear-gradient(
                to right,
                #e0e0e0 0%,
                #f5f5f5 20%,
                #e0e0e0 40%,
                #e0e0e0 100%
              );
              background-repeat: no-repeat;
              background-size: 1000px 200px;
              animation-duration: 1.5s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
              animation-name: shimmerAnimation;
              animation-timing-function: linear;
            }

            .button-placeholder {
              height: 100px;
              background-color: #e0e0e0;
              margin-bottom: 15px;
            }

            .promo-placeholder {
              height: 160px;
              background-color: #e0e0e0;
              margin-bottom: 10px;
              background-image: linear-gradient(
                to right,
                #e0e0e0 0%,
                #f5f5f5 20%,
                #e0e0e0 40%,
                #e0e0e0 100%
              );
              background-repeat: no-repeat;
              background-size: 1000px 100px;
              animation-duration: 1.5s;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
              animation-name: shimmerAnimation;
              animation-timing-function: linear;
            }

            .promos-row {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              gap: 10px;
            }

            .promo-item {
              flex: 0 0 30%; /* Adjust based on the number of items per row */
            }
          `}
        </style>
        <div className="banner-placeholder"></div>
        <div className="button-placeholder" />
        <div className="promos-row">
          {/* Repeat the .promo-item as many times as needed */}
          <div className="promo-item promo-placeholder"></div>
          <div className="promo-item promo-placeholder"></div>
          <div className="promo-item promo-placeholder"></div>
        </div>
        <div className="banner-placeholder"></div>
        <div className="banner-placeholder"></div>
        <div className="banner-placeholder"></div>
        <div className="banner-placeholder"></div>
      </div>
    );
  }
}
